import {
  Grid,
  Dialog,
  DialogContent,
  Button,
  TextField,
  CircularProgress,
  DialogActions,
  DialogTitle,
} from '@mui/material'
import { isEqual } from 'lodash'
import { memo, useCallback, useRef, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import { MdBarcodeReader } from 'react-icons/md'

export const ModalDispensacao = ({
  show,
  handleClose,
  dados,
  setReloadTable,
}) => {
  const inputRef = useRef(null)
  const [codigo, setCodigo] = useState('')
  const [qtSolicitado] = useState(dados[9] || 0)
  const [qtDispensado] = useState(dados[10] || 0)
  const [loading, setLoading] = useState(false)
  const [loadingScanner, setLoadingScanner] = useState(false)

  const [qtParaDispensarAgora, setQtParaDispensarAgora] = useState(1)
  const [erroQtd, setErroQtd] = useState('')
  const [erroCodigoBarras, setErroCodigoBarra] = useState('')

  const restante = dados[9] - (dados[10] || 0)

  function focarLeitor() {
    setCodigo('')
    if (inputRef.current) {
      setLoadingScanner(true)
      inputRef.current.focus()
    }
  }

  function handleChangeQtd(e) {
    const valor = e.target.value

    if (valor === '') {
      setQtParaDispensarAgora('')
      setErroQtd('Informe a quantidade a dispensar')
      return
    }

    const numero = Number(valor)

    if (numero <= 0) {
      setQtParaDispensarAgora(0)
      setErroQtd('A quantidade deve ser maior que zero')
      return
    }

    if (numero > restante) {
      setQtParaDispensarAgora(restante)
      setErroQtd(`Você só pode dispensar até ${restante} agora`)
      return
    }

    setQtParaDispensarAgora(numero)
    setErroQtd('')
  }

  function manterFoco() {
    setTimeout(() => {
      if (!isValidGTIN(codigo)) {
        inputRef.current?.focus()
      } else {
        setLoadingScanner(false)
      }
    }, 50)
  }

  const confirmaDispensacao = useCallback(() => {
    const payload = {
      idDispensacao: dados[0],
      nrItem: dados[1],
      qtDispensado: qtParaDispensarAgora,
      cdGtin: codigo,
    }
    metodoPrograma('dispensaItem', payload).then((res) => {
      if (res.status) {
        setLoading(false)
        handleClose()
        setReloadTable((v) => !v)
      }
    })
  }, [dados, codigo, handleClose, qtParaDispensarAgora, setReloadTable])

  function handleChange(e) {
    const valor = e.target.value
    const limpo = valor.replace(/\D/g, '') // só números

    setCodigo(limpo)

    if (limpo !== '') {
      setLoadingScanner(false)
    }
    if (!isValidGTIN(limpo)) {
      setErroCodigoBarra('Código de barras inválido')
    } else {
      setErroCodigoBarra('')
      setLoadingScanner(false)
      processarCodigo()
    }
  }

  function isValidGTIN(gtin) {
    if (!/^\d{8}$|^\d{12}$|^\d{13}$|^\d{14}$/.test(gtin)) {
      return false
    }

    let sum = 0
    let multiplyByThree = true

    for (let i = gtin.length - 2; i >= 0; i--) {
      const digit = parseInt(gtin[i], 10)
      sum += multiplyByThree ? digit * 3 : digit
      multiplyByThree = !multiplyByThree
    }

    const checkDigit = (10 - (sum % 10)) % 10
    const providedCheckDigit = parseInt(gtin[gtin.length - 1], 10)

    return checkDigit === providedCheckDigit
  }

  function processarCodigo() {
    inputRef.current?.blur()
  }

  return (
    <Dialog maxWidth="lg" open={show} onClose={handleClose} fullWidth>
      <DialogTitle>Confirmando dispensação</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Código Produto"
              value={dados[4]}
              fullWidth
              disabled
              margin="dense"
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Lote Produto"
              value={dados[6]}
              fullWidth
              disabled
              margin="dense"
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={8}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Nome Produto"
              value={dados[5]}
              fullWidth
              disabled
              margin="dense"
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Fabricação"
              value={dados[9]}
              fullWidth
              disabled
              margin="dense"
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Validade"
              value={dados[9]}
              fullWidth
              disabled
              margin="dense"
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Quantidade Solicitada"
              value={dados[9]}
              fullWidth
              disabled
              margin="dense"
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label={`Quantidade a dispensar agora (restante: ${restante})`}
              value={qtParaDispensarAgora}
              onChange={handleChangeQtd}
              fullWidth
              type="number"
              margin="dense"
              variant="outlined"
              size="small"
              error={!!erroQtd}
              helperText={
                erroQtd || `Já dispensado: ${qtDispensado} de ${qtSolicitado}`
              }
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              inputRef={inputRef}
              InputLabelProps={{ shrink: true }}
              label="Digite ou escaneie o código de barras"
              placeholder="Digite ou escaneie o código de barras"
              value={codigo}
              onChange={handleChange}
              onBlur={manterFoco}
              fullWidth
              type="number"
              margin="dense"
              variant="outlined"
              size="small"
              error={!!erroCodigoBarras}
              helperText={erroCodigoBarras || ''}
            />
          </Grid>
          <Grid item xs={4}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={focarLeitor}
              style={{ marginTop: '9px' }}
              startIcon={<MdBarcodeReader />}
              endIcon={
                loadingScanner ? (
                  <CircularProgress color="inherit" size={15} />
                ) : null
              }
            >
              usar scanner
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          disabled={erroCodigoBarras !== ''}
          onClick={confirmaDispensacao}
          style={{ margin: '5px' }}
          endIcon={
            loading ? <CircularProgress color="inherit" size={15} /> : null
          }
        >
          Confirmar dispensação
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default memo(ModalDispensacao, isEqual)
